import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadAuftragsStatusArtListStatus: 'idle',
    loadAuftragsStatusArtListError: undefined as any,
    loadAuftragsStatusArtListLastArgs: undefined as any,
    loadAuftragsStatusArtStatus: 'idle',
    loadAuftragsStatusArtError: undefined as any,
    saveAuftragsStatusArtStatus: 'idle',
    saveAuftragsStatusArtError: undefined as any,
    deleteAuftragsStatusArtStatus: 'idle',
    deleteAuftragsStatusArtError: undefined as any,

    auftragsStatusArtList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadAuftragsStatusArtList = createAsyncThunk('auftragsStatusArtSlice/loadAuftragsStatusArtList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().auftragsStatusArtSlice.loadAuftragsStatusArtListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisauftstatart/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragsStatusArtListStatus } = getState().auftragsStatusArtSlice
        return loadAuftragsStatusArtListStatus !== 'pending'
    }
})

export const loadAuftragsStatusArt = createAsyncThunk('auftragsStatusArtSlice/loadAuftragsStatusArt', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisauftstatart/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragsStatusArtStatus } = getState().auftragsStatusArtSlice
        return loadAuftragsStatusArtStatus !== 'pending'
    }
})

export const saveAuftragsStatusArt = createAsyncThunk('auftragsStatusArtSlice/saveAuftragsStatusArt', async ({ auftragsStatusArt }: any, { rejectWithValue }: any) => {
    let promises = []
    if (auftragsStatusArt?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurisauftstatart/${ auftragsStatusArt?.HDR_ID }/`,
            prepareData(auftragsStatusArt),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurisauftstatart/`,
            prepareData(auftragsStatusArt),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveAuftragsStatusArtStatus } = getState().auftragsStatusArtSlice
        return saveAuftragsStatusArtStatus !== 'pending'
    }
})

export const deleteAuftragsStatusArt = createAsyncThunk('auftragsStatusArtSlice/deleteAuftragsStatusArt', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurisauftstatart/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteAuftragsStatusArtStatus } = getState().auftragsStatusArtSlice
        return deleteAuftragsStatusArtStatus !== 'pending'
    }
})

const AuftragsStatusArtSlice = createSlice({
    name: 'auftragsStatusArtSlice',
    initialState,
    reducers: {
        resetloadAuftragsStatusArtListError: (state) => {
            state.loadAuftragsStatusArtListError = undefined
        },
        resetloadAuftragsStatusArt: (state) => {
            state.formItem = undefined
            state.loadAuftragsStatusArtError = undefined
        },
        resetloadAuftragsStatusArtError: (state) => {
            state.loadAuftragsStatusArtError = undefined
        },
        resetsaveAuftragsStatusArt: (state) => {
            state.formItem = undefined
            state.saveAuftragsStatusArtError = undefined
        },
        resetsaveAuftragsStatusArtError: (state) => {
            state.saveAuftragsStatusArtError = undefined
        },
        resetdeleteAuftragsStatusArtError: (state) => {
            state.deleteAuftragsStatusArtError = undefined
        },
        removeFromAuftragsStatusArtListById: (state, action) => {
            state.auftragsStatusArtList = state.auftragsStatusArtList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromAuftragsStatusArtListByIds: (state, action) => {
            state.auftragsStatusArtList = state.auftragsStatusArtList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.auftragsStatusArtList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadAuftragsStatusArtListStatus = 'preloaded'
            state.loadAuftragsStatusArtListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.auftragsStatusArtList = []
            state.loadAuftragsStatusArtListStatus = 'idle'
            state.loadAuftragsStatusArtListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadAuftragsStatusArtList.pending, (state) => {
            state.loadAuftragsStatusArtListStatus = 'pending'
            state.loadAuftragsStatusArtListError = undefined
        })
        builder.addCase(loadAuftragsStatusArtList.fulfilled, (state, action) => {
            state.loadAuftragsStatusArtListStatus = 'idle'

            if (!action.payload) { return }

            state.loadAuftragsStatusArtListLastArgs = action.payload.args

            {
                state.auftragsStatusArtList = action.payload.data

            }
        })
        builder.addCase(loadAuftragsStatusArtList.rejected, (state, action) => {
            state.loadAuftragsStatusArtListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragsStatusArtListError = action.error.message
            } else {
                state.loadAuftragsStatusArtListError = action.payload
            }
        })

        builder.addCase(loadAuftragsStatusArt.pending, (state) => {
            state.loadAuftragsStatusArtStatus = 'pending'
            state.loadAuftragsStatusArtError = undefined
        })
        builder.addCase(loadAuftragsStatusArt.fulfilled, (state, action) => {
            state.loadAuftragsStatusArtStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragsStatusArtList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragsStatusArtList.push(newItem) }
                else { state.auftragsStatusArtList[i] = { ...state.auftragsStatusArtList[i], ...newItem } }
            }
        })
        builder.addCase(loadAuftragsStatusArt.rejected, (state, action) => {
            state.loadAuftragsStatusArtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragsStatusArtError = action.error.message
            } else {
                state.loadAuftragsStatusArtError = action.payload
            }
        })

        builder.addCase(saveAuftragsStatusArt.pending, (state) => {
            state.saveAuftragsStatusArtStatus = 'pending'
            state.saveAuftragsStatusArtError = undefined
        })
        builder.addCase(saveAuftragsStatusArt.fulfilled, (state, action) => {
            state.saveAuftragsStatusArtStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragsStatusArtList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragsStatusArtList.push(newItem) }
                else { state.auftragsStatusArtList[i] = { ...state.auftragsStatusArtList[i], ...newItem } }
            }
        })
        builder.addCase(saveAuftragsStatusArt.rejected, (state, action) => {
            state.saveAuftragsStatusArtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveAuftragsStatusArtError = action.error.message
            } else {
                state.saveAuftragsStatusArtError = action.payload
            }
        })

        builder.addCase(deleteAuftragsStatusArt.pending, (state) => {
            state.deleteAuftragsStatusArtStatus = 'pending'
            state.deleteAuftragsStatusArtError = undefined
        })
        builder.addCase(deleteAuftragsStatusArt.fulfilled, (state, action) => {
            state.deleteAuftragsStatusArtStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.auftragsStatusArtList = state.auftragsStatusArtList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.auftragsStatusArtList = state.auftragsStatusArtList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteAuftragsStatusArt.rejected, (state, action) => {
            state.deleteAuftragsStatusArtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteAuftragsStatusArtError = action.error.message
            } else {
                state.deleteAuftragsStatusArtError = action.payload
            }
        })

    }
})

export const {
    resetloadAuftragsStatusArtListError,
    resetloadAuftragsStatusArt,
    resetloadAuftragsStatusArtError,
    resetsaveAuftragsStatusArt,
    resetsaveAuftragsStatusArtError,
    resetdeleteAuftragsStatusArtError,
    removeFromAuftragsStatusArtListById,
    removeFromAuftragsStatusArtListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = AuftragsStatusArtSlice.actions
export default AuftragsStatusArtSlice.reducer
